import { Platform } from 'react-native';

import { BorderStyles, ItemLocation } from './types';

export const getBorderStyles = (
  scaledBorderRadius: number,
  location?: ItemLocation
): BorderStyles => {
  const showLeftBorder = location !== ItemLocation.START;
  const showLeftRadii = location === ItemLocation.START;
  const showRightBorder = location !== ItemLocation.END;
  const showRightRadii = location === ItemLocation.END;
  const isIos = Platform.OS === 'ios';

  // iOS RN workaround: Prevent rendering artifacts caused by inconsistent borderRadius
  // and borderWidth. Solution: use consistent values (borderWidth: 1px, minRadius: 2px) on all
  // sides and control border visibility with transparent borderColor
  const minRadius = isIos ? 2 : 0;

  return {
    borderTopLeftRadius: showLeftRadii ? scaledBorderRadius : minRadius,
    borderTopRightRadius: showRightRadii ? scaledBorderRadius : minRadius,
    borderBottomLeftRadius: showLeftRadii ? scaledBorderRadius : minRadius,
    borderBottomRightRadius: showRightRadii ? scaledBorderRadius : minRadius,
    borderLeftWidth: showLeftBorder ? 1 : 0,
    borderRightWidth: showRightBorder ? 1 : 0,
    ...(isIos
      ? {
          borderLeftColor: showLeftBorder ? 'white' : 'transparent',
          borderRightColor: showRightBorder ? 'white' : 'transparent',
        }
      : {
          overflow: 'hidden',
        }),
  };
};
